export default __webpack_public_path__ + "static/poster-1d0e8c7ba1db6ba8d9dfafdeb816b976.png";